/**
 * NoteActions Components
 *
 * Action button components for notes (edit, delete, approve, discard).
 */

import React from "react";

interface ActionButtonProps {
  onClick: () => void;
  disabled?: boolean;
  className?: string;
  children: React.ReactNode;
}

const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  disabled = false,
  className = "",
  children,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className={`text-xs transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${className}`}
    >
      {children}
    </button>
  );
};

interface EditButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const EditButton: React.FC<EditButtonProps> = ({ onClick, disabled }) => {
  return (
    <ActionButton
      onClick={onClick}
      disabled={disabled}
      className="text-blue-600 hover:text-blue-800"
    >
      Edit
    </ActionButton>
  );
};

interface DeleteButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <ActionButton
      onClick={onClick}
      disabled={disabled}
      className="text-red-600 hover:text-red-800"
    >
      Delete
    </ActionButton>
  );
};

interface ApproveButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const ApproveButton: React.FC<ApproveButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="px-3 py-1 text-sm font-medium text-white bg-emerald-600 rounded-sm hover:bg-emerald-700 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Approve
    </button>
  );
};

interface DiscardButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const DiscardButton: React.FC<DiscardButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="px-3 py-1 text-sm font-medium text-rose-600 hover:bg-rose-50 rounded-sm disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Discard
    </button>
  );
};

interface ClearButtonProps {
  onClick: () => void;
  disabled?: boolean;
}

export const ClearButton: React.FC<ClearButtonProps> = ({
  onClick,
  disabled,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="text-xs text-gray-500 hover:text-gray-700 disabled:opacity-50 disabled:cursor-not-allowed"
    >
      Clear
    </button>
  );
};
